/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';

interface ActionPopoverIconArgs {
  action: ActionModel;
  hasReadOnlyPermission: boolean;
}

export default class ActionPopoverIconComponent extends Component<ActionPopoverIconArgs> {
  get popoverModifierClass() {
    if (this.args.action?.info?.group == null) {
      return null;
    }

    return `action-popover-icon-popup action-popover-icon-popup--${this.args.action.info.group}`;
  }
}
